<template>
  <subject-info-form
    :serverValidations="serverValidations"
    @on-submit="addSubject"
  >
  </subject-info-form>
</template>

<script>
import SubjectInfoForm from "./SubjectInfoform.vue";
import { service_paths } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import { genErrMsgOj } from "@/helpers/utils";
import { subject_router_names } from "@/routes/routes";
export default {
  components: { SubjectInfoForm },
  data() {
    return {
      serverValidations: {}
    };
  },
  methods: {
    addSubject(form) {
      this.$axios
        .post(service_paths.subjects, form)
        .then(() => {
          Message.success(this.$t("common.add_success"));
          this.$router.push({ name: subject_router_names.listPage });
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            this.serverValidations = genErrMsgOj(errData.messages);
          }
        });
    }
  }
};
</script>

<style></style>
